<template>
  <div id="home">
    <Search />
    <div class="db-projects">
      <div class="tabs-main">
        <v-container>
          <!--<Widget position="main_tab_1_title" />-->
          <Widget position="main_tab_1" :useTab="true" />
        </v-container>
      </div>
      <div class="wgt-theme-black last-posts">
        <v-container>
          <!--<Widget position="main_tab_2_title" />-->
          <!--<Widget position="main_tab_2" :useTab="true" />-->
          <v-row>
            <v-col
              sm="12"
              md="6"
              lg="6"
            >
              <Widget position="recent_projects" />
            </v-col>
            <v-col
              sm="12"
              md="6"
              lg="6"
            >
              <Widget position="most_talked" />
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>

    <!-- Блок рекламы -->
    <div class="wgt-theme-black advertising">
      <v-container>
        <div class="review-list">
          <Widget position="main_advertising" />
          <Widget position="main_advertising_button" />
        </div>
      </v-container>
    </div>

    <!-- О портале -->
    <div class="wgt-theme-black about-portal" :on="handleScroll">
      <v-container>
        <!--<Widget position="main_tab_3_title" />-->
        <!--<Widget position="main_tab_3" :useTab="true" />-->
        <div class="position">
          <v-row>
              <v-col
                  class="animated"
                  :class="{'is-showing': scrolled}"
              >
                <Widget position="about_us" />
              </v-col>
              <v-col
                  class="animated"
                  :class="{'is-showing': scrolled}"
              >
                <Widget position="for_users" />
              </v-col>
              <v-col
                  class="animated"
                  :class="{'is-showing': scrolled}"
              >
                <Widget position="for_employees" />
              </v-col>
          </v-row>
        </div>
      </v-container>
    </div>

    <!-- Схема обсуждения проектов -->
    <div class="wgt-theme-black scheme-discussions">
      <v-container>
        <Widget position="main_scheme" />
      </v-container>
    </div>

    <!-- статистики портала -->
    <div class="wgt-theme-black statistics">
      <v-container>
        <Widget position="main_statistic" />
      </v-container>
    </div>

    <!-- топ (комменты, пользователи, органы) -->
    <div class="wgt-theme-black popular-column">
      <v-container>
        <Widget position="main_popular" />
      </v-container>
    </div>

    <div class="wgt-theme-black">
      <v-container>
        <div class="position">
          <div class="bg-white p-20">
            <Widget position="main_rating" />
          </div>
        </div>
      </v-container>
    </div>

    <div class="wgt-theme-black partners-carousel">
      <v-container>
        <div class="position">
          <div class="bg-white">
            <Widget position="banner_carousel" />
          </div>
        </div>
      </v-container>
    </div>

    <div class="wgt-theme-black last-posts">
      <v-container>
          <Widget position="viewed_npas" />
      </v-container>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search'
import Widget from '@/components/app/Widget'

export default {
  components: {
    Search,
    Widget
  },
  data() {
    return {
      scrolled: false
    }
  },
  metaInfo () {
    return {
      title: this.$i18n.t('homeTitleSEO'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.$i18n.t('homeDescriptionSEO'),
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.$i18n.t('homeKeywordsSEO'),
      }]
    }
  },
  methods: {
    handleScroll() {
      let obj = document.querySelector('.about-portal');
      let {top,bottom} = obj.getBoundingClientRect();
      let height = document.documentElement.clientHeight;
      this.scrolled = top < height && bottom >0;
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);

  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
